import { Box, IconButton, ListItem, Typography } from '@mui/material';
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ListItemComponent = ({ fileName, fileSize, onRemove, fileSrc }) => {
const {t} = useTranslation()
  const isPDF = fileSrc.toLowerCase().endsWith('.pdf');
  return (
    <ListItem sx={{ border: "1px solid", borderRadius: "7px", display: "flex", justifyContent: "space-around" , marginBottom:".5rem" }}>
      {/* Conditionally render thumbnail or fileSrc */}
      <img
      width={64}
      height={64}
        src={isPDF ? "/images//pdf.webp" : fileSrc}
        alt={fileName}
        style={{  margin: '0 10px', height:"90px" , width:"64px", border:"1px solid  #bababa" }} // Adjust width and height as needed
      />

      <Box className='mr-2 flex flex-col w-3/4'>
        <Link to={fileSrc} target='_blank' sx={{ textOverflow: "ellipsis" ,  }}>
          <Typography variant='h4' sx={{ textOverflow: "ellipsis" ,marginBottom:"0.6rem" , textDecoration:"underline" }}>{t("Upload.File")} {fileName} </Typography>
        </Link>
        <Typography variant='subtitle'>{fileSize}</Typography>
      </Box>

      <IconButton  
        sx={{
          backgroundColor: "#C81D11", 
          color: "white", 
          border: "3px solid #f29791",
          '&:hover': {
            backgroundColor: "#C81D11",
          },
          '&:active': {
            backgroundColor: "#C81D11",
          }
        }} 
        aria-label="delete" 
        onClick={onRemove}
      >
        <DeleteIcon />
      </IconButton>
    </ListItem>
  );
};

export default ListItemComponent;
